<template>
  <VueApexCharts type="donut" width="380" :options="chartOptions" :series="series" />
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

const colors = [
  '#FF766A',
  '#FFCC91',
  '#2979FF',
  '#B7FFB1',
  '#FF88B4',
  '#FF9900',
  '#5968AD',
  '#97A5EB',
];

export default {
  components: { VueApexCharts },
  props: {
    sources: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return this.sources.map(source => source.count_jobs);
    },
    total() {
      let total = 0;
      // eslint-disable-next-line array-callback-return
      this.sources.map(source => {
        total += source.count_jobs;
      });
      return total;
    },
    chartOptions() {
      return {
        chart: {
          width: 250,
          type: 'donut',
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                  formatter(w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10,
                  formatter() {
                    return 'Total';
                  },
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter(w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        colors: [...colors, ...colors, ...colors],
        labels: this.sources.map(source => source.source_name),
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              stroke: {
                show: false,
              },
              legend: {
                show: true,
              },
            },
          },
          {
            breakpoint: 800,
            options: {
              chart: {
                width: 400,
              },
              stroke: {
                show: false,
              },
              legend: {
                show: true,
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 250,
              },
              stroke: {
                show: false,
              },
              legend: {
                show: false,
              },
            },
          },
          {
            breakpoint: 1700,
            options: {
              chart: {
                width: 300,
              },
              stroke: {
                show: false,
              },
              legend: {
                show: true,
              },
            },
          },
          {
            breakpoint: 2000,
            options: {
              chart: {
                width: 400,
              },
              stroke: {
                show: false,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          show: true,
          position: 'left',
          labels: {
            colors: '#a9a9a9',
          },
          markers: {
            width: 10,
            height: 10,
          },
          formatter(seriesName, opts) {
            return `<div class="d-flex align-items-center justify-content-between w-100"><span style="font-size: 11px">${seriesName}</span>  <span style="color: black">${
              opts.w.globals.series[opts.seriesIndex]
            }</span></div>`;
          },
        },
      };
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/BooksSource/BooksSourceChart.vue